import { set_url_store } from "../confg";
import { createReducer } from '@reduxjs/toolkit';

const last_storePlace_url = createReducer('/', {
    [set_url_store]: (state, action) => {
        return action.payload
    }
});

export default last_storePlace_url;